import React from "react";
import { DashboardModuleAlertsComponent } from "@app/dashboard/controls/DashboardModuleAlerts/DashboardModuleAlertsComponent";
import { useAlerts } from "@app/contexts/useAlerts";
import { useAlertStatus } from "@app/contexts/useAlerts/useAlertStatus";
import { useSpecialty } from "@app/specialty/hooks/useSpecialty";


export const DashboardModuleAlertsContainer = () => <DashboardModuleAlertsComponent useAlerts={useAlerts} useAlertStatus={useAlertStatus} useSpecialty={useSpecialty}/>;

